/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplicationType } from '../models/ApplicationType';
import type { DictionariesResultDto } from '../models/DictionariesResultDto';
import type { DictionariesResultV2Dto } from '../models/DictionariesResultV2Dto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class ResourcesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @deprecated
     * @param culture
     * @param application
     * @returns DictionariesResultDto Success
     * @throws ApiError
     */
    public getApiResourcesDictionaries(
        culture?: string,
        application?: ApplicationType,
    ): CancelablePromise<DictionariesResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/resources/dictionaries',
            query: {
                'culture': culture,
                'application': application,
            },
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param culture
     * @param application
     * @returns DictionariesResultV2Dto Success
     * @throws ApiError
     */
    public getApiResourcesV2Dictionaries(
        culture?: string,
        application?: ApplicationType,
    ): CancelablePromise<DictionariesResultV2Dto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/resources/v2/dictionaries',
            query: {
                'culture': culture,
                'application': application,
            },
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @returns any Success
     * @throws ApiError
     */
    public getApiResourcesClearcache(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/resources/clearcache',
        });
    }
}
